export default "__VITE_ASSET__e2da6922__"